import { ArtifactType, UserRequestStatus } from '@/shared/types';

import { StatusDecorator } from '@/api/types';

export type IACUserRequestStatus = UserRequestStatus.IN_PROCESS | UserRequestStatus.FINISHED;

export enum IACUserRequestChannel {
  DII = 'DII',
  EXT = 'EXT',
  CIC = 'CIC',
  SCE = 'SCE',
  DPI = 'DPI',
  DMI = 'DMI',
  DCI = 'DCI',
  CNA = 'CNA',
  VPR = 'VPR',
  TSC = 'TSC',
  MVC = 'MVC',
}

export interface IACUserRequest {
  id: string;
  status: IACUserRequestStatus;
  status_decorator?: Nullable<StatusDecorator>;
  esn: string;
  created_at: string;
  completed_at: string;
  purpose_id: string;
  purpose_name: string;
  channel: IACUserRequestChannel;
  artifacts: ArtifactType[];
}
